import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R, isNotFoundError } from 'core/helpers'
import { useLoanGet } from 'core/types'

import ModelLink from './ModelLink'

type LoanLinkProps = {
  loanId: string
}

const LoanLink: FC<LoanLinkProps> = ({ loanId }) => {
  const [_, { personId }] = useQueryApi()
  const { data: loan, isLoading } = useLoanGet({
    personId,
    loanId,
    options: { throwOnError: R.isNot(isNotFoundError) },
  })

  return <ModelLink id={loanId} isLoading={isLoading} model={loan} />
}

export default LoanLink
